import React from "react"
import CustomPageHeader from "../fragments/CustomPageHeader"

export default function Batches({ children }) {
  return (
    <div>
      <CustomPageHeader icon='mobile' text='Devices' />
      { children }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Batches/index.js